import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { WriteUsService } from './../../../../service/write-us-service';
import { WriteUsDto } from './../../../../model/write-us-dto';
import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { CustomMessages } from '@shared';

@Component({
  selector: 'app-writeus',
  templateUrl: './writeus.component.html',
  styleUrls: ['./writeus.component.scss']
})
export class WriteusComponent implements OnInit {
  //Variables
  subject: string;
  remarks: string;
  status: number;

  //Send DTO to Java
  writeUsDto: WriteUsDto = new WriteUsDto();

  //Output Emitter
  @Output() closePanelWriteUs: EventEmitter<boolean> = new EventEmitter();

  //Reactive Form Group
  writeUsForm = new FormGroup({
    'subject': new FormControl('', [Validators.required, Validators.maxLength(100)]),
    'remarks': new FormControl('', [Validators.required, Validators.maxLength(1000)]),
  });

  constructor(private writeUsService: WriteUsService, private sidebarComponent: SidebarComponent, private customMessage: CustomMessages) { }

  ngOnInit() {
  }

  closed() {
    this.closePanelWriteUs.emit(false);
  }

  resetForm() {
    this.writeUsForm.reset();

  }
  sendWriteUsMail() {
    this.writeUsDto.subject = this.writeUsForm.get('subject').value;
    this.writeUsDto.remarks = this.writeUsForm.get('remarks').value;
    this.writeUsService.sendWriteUsMail(this.writeUsDto).subscribe((data: any) => {
      this.status = data.status;
      if (this.status == 0) {
        this.customMessage.showErrorMessage("cams.label.common.mailNotSend", '');
      }
      //SUCCESS AND CLOSE POP-UP
      if (this.status == 1) {
        this.customMessage.showSuccessMessage("cams.label.common.mailSentSuccessfully"); this.closed();
      }
    });
  }
}
